import { XIcon } from 'lucide-react'
import { useT } from '@/session/useSession'
import { IconButton } from '../IconButton/IconButton'
import styles from './FilterChips.module.css'

export type FilterChip = { name: string; label: string; value: string }

export type FilterChipsProps = {
  chips: FilterChip[]
  onRemove: (name: string) => void
}

export function FilterChips({ chips, onRemove }: FilterChipsProps) {
  const t = useT()

  if (chips.length === 0) return null

  return (
    <div className={styles.chips}>
      <span className={styles.legend}>{t('filters.active')}</span>
      <ul className={styles.list}>
        {chips.map((chip) => (
          <li key={chip.name} className={styles.chip}>
            <span className={styles.label}>{chip.label}</span>
            <span className={styles.value}>{chip.value}</span>
            <IconButton
              className={styles.remove}
              label={t('filters.remove', { filter: chip.label })}
              onClick={() => onRemove(chip.name)}
            >
              <XIcon />
            </IconButton>
          </li>
        ))}
      </ul>
    </div>
  )
}
